import React from 'react';
import { Checkbox } from '@fluentui/react-components';

export default function UiCheckbox(props) {
    return <Checkbox {...props} />;
}
